import { render, staticRenderFns } from "./pages16.vue?vue&type=template&id=268c745a&scoped=true&"
import script from "./pages16.vue?vue&type=script&lang=js&"
export * from "./pages16.vue?vue&type=script&lang=js&"
import style0 from "./pages16.vue?vue&type=style&index=0&id=268c745a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c745a",
  null
  
)

export default component.exports